// Views
import GarageExclusionList from '../../views/garage-exclusions/GarageExclusionsList';
import ErrorFallback from '../../views/ErrorFallback';

// Components
import ProtectedRoute from '../ProtectedRoute';

/**
 *  @type {Route[]}
 */
export const garageExclusionsPrivateRoutes = [
  {
    path: '/garage-exclusions',
    element: <ProtectedRoute><GarageExclusionList /></ProtectedRoute>,
    errorElement: <ErrorFallback />,
  },
];
